import { topicsData, updatesData, appData, featuresData } from '@/mocks/home';

const cardsItems = [
  { id: 1, title: '韩漫：从网漫到全球现象', desc: '韩国网络漫画凭借独特的竖屏滚动格式和精良的全彩作画，已从本土走向世界。虫虫动漫收录最热门韩漫作品，带你领略K-Webtoon的魅力。', tag: '韩漫文化', imgUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20colorful%20comic%20pages%20displayed%20on%20a%20modern%20tablet%20with%20warm%20ambient%20lighting%2C%20cozy%20reading%20nook%20with%20plants%2C%20soft%20orange%20and%20amber%20tones%2C%20editorial%20photography%20style%2C%20clean%20minimal%20background&width=800&height=450&seq=card-kr-01&orientation=landscape' },
  { id: 2, title: '日漫：跨越百年的漫画王国', desc: '日本漫画承载着几代人的青春记忆，从少年JUMP到青年漫画，丰富的题材和深度的叙事让日漫成为不可替代的文化符号。', tag: '日漫经典', imgUrl: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20classic%20volumes%20stacked%20on%20a%20wooden%20desk%20with%20warm%20reading%20lamp%2C%20artistic%20flat%20lay%20composition%2C%20soft%20natural%20light%2C%20orange%20and%20cream%20color%20palette%2C%20editorial%20photography%2C%20harmonious%20arrangement&width=800&height=450&seq=card-jp-01&orientation=landscape' },
  { id: 3, title: '国漫：东方美学的数字新生', desc: '国产漫画正经历前所未有的黄金时代，融合中国传统文化与现代审美，从玄幻仙侠到都市现实，国漫的叙事边界不断拓展。', tag: '国漫崛起', imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%20with%20traditional%20ink%20wash%20painting%20style%20blended%20with%20modern%20digital%20illustration%2C%20beautiful%20characters%20in%20flowing%20robes%2C%20warm%20golden%20and%20amber%20lighting%2C%20artistic%20composition%2C%20elegant%20atmosphere&width=800&height=450&seq=card-cn-01&orientation=landscape' },
];

const cardsItemsRow = [
  { id: 4, title: '下拉式阅读：重新定义看漫画', desc: '传统的翻页阅读正在被下拉式滚动取代。无需点击，只需滑动手指或滚轮，画面自然衔接，带来沉浸式连续阅读体验。', tag: '阅读体验', imgUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20digital%20comic%20with%20vertical%20scrolling%20format%2C%20finger%20gently%20swiping%20on%20screen%2C%20cozy%20cafe%20background%20with%20warm%20lighting%2C%20modern%20minimal%20aesthetic%2C%20editorial%20photography%20style&width=600&height=400&seq=card-scroll-01&orientation=landscape' },
  { id: 5, title: '漫画分类指南：找到你的菜', desc: '面对海量漫画不知从何看起？从热度排行到标签筛选，虫虫动漫的多维分类系统帮你精准定位心仪作品。', tag: '选漫攻略', imgUrl: 'https://readdy.ai/api/search-image?query=Organized%20comic%20book%20collection%20on%20shelves%20with%20colorful%20spines%20and%20covers%2C%20cozy%20library%20corner%20with%20warm%20reading%20lamp%2C%20soft%20natural%20light%2C%20inviting%20atmosphere%2C%20editorial%20style%20photography&width=600&height=400&seq=card-guide-01&orientation=landscape' },
];

const mediaItems = [
  { id: 1, title: '《我独自升级》动画化决定', desc: '现象级韩漫改编动画即将上线，制作阵容豪华', tag: '韩漫', imgUrl: 'https://readdy.ai/api/search-image?query=Exciting%20anime%20style%20illustration%20with%20dynamic%20action%20scene%2C%20Korean%20webtoon%20inspired%20art%2C%20vibrant%20warm%20colors%20with%20orange%20and%20amber%20highlights%2C%20dramatic%20lighting%2C%20modern%20clean%20composition&width=640&height=360&seq=media-kr-01&orientation=landscape' },
  { id: 2, title: 'JUMP新连载引发热议', desc: '周刊少年JUMP最新连载作品首话好评如潮', tag: '日漫', imgUrl: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20magazine%20cover%20style%20illustration%20with%20energetic%20characters%2C%20bold%20typography%2C%20vivid%20warm%20colors%2C%20shonen%20jump%20aesthetic%2C%20dynamic%20composition%2C%20modern%20clean%20design&width=640&height=360&seq=media-jp-01&orientation=landscape' },
  { id: 3, title: '国产漫改剧再添力作', desc: '多部热门国漫IP确认影视化改编，期待值拉满', tag: '国漫', imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20fantasy%20illustration%20with%20flowing%20silk%20robes%20and%20magical%20effects%2C%20warm%20golden%20lighting%2C%20epic%20cinematic%20composition%2C%20traditional%20Chinese%20art%20style%20blended%20with%20modern%20digital%20art&width=640&height=360&seq=media-cn-01&orientation=landscape' },
  { id: 4, title: '2026夏季新番推荐', desc: '本季最值得追的漫画新作大盘点，不容错过', tag: '推荐', imgUrl: 'https://readdy.ai/api/search-image?query=Colorful%20manga%20book%20display%20with%20various%20new%20releases%2C%20summer%20vibes%20with%20warm%20sunlight%2C%20cozy%20reading%20corner%2C%20vibrant%20orange%20and%20golden%20tones%2C%20editorial%20photography%20style%2C%20inviting%20atmosphere&width=640&height=360&seq=media-new-01&orientation=landscape' },
];

const carouselItems = [
  { id: 1, title: '韩漫特辑：热血与浪漫的双重奏', desc: '从《我独自升级》的燃炸战斗到《某天成为公主》的甜蜜心跳，韩漫用精致的全彩画风和独特的叙事节奏征服了全球读者。本期专题带你深入韩漫的多元世界。', tag: '韩漫', imgUrl: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20colorful%20comic%20art%20collection%20with%20dynamic%20action%20scenes%20and%20romantic%20moments%2C%20beautiful%20full%20color%20illustrations%2C%20warm%20amber%20and%20orange%20lighting%2C%20modern%20digital%20art%20style%2C%20editorial%20quality&width=800&height=500&seq=carousel-kr-01&orientation=landscape' },
  { id: 2, title: '日漫经典：那些年我们追过的神作', desc: '《全职猎人》《咒术回战》《海贼王》……这些名字承载着无数人的青春。日漫的魅力在于它从不设限——热血、悬疑、搞笑、治愈，总有一部能击中你的心。', tag: '日漫', imgUrl: 'https://readdy.ai/api/search-image?query=Classic%20Japanese%20manga%20volumes%20collection%20displayed%20artistically%20with%20warm%20lighting%2C%20nostalgic%20atmosphere%2C%20various%20famous%20shonen%20manga%20covers%2C%20wooden%20shelves%2C%20cozy%20reading%20room%2C%20editorial%20photography%20style&width=800&height=500&seq=carousel-jp-01&orientation=landscape' },
  { id: 3, title: '国漫之光：东方美学的数字表达', desc: '《斗破苍穹》《完美世界》《一人之下》……国漫正在用独特的东方叙事和日益精进的制作水准，向世界展示中国漫画的无限可能。', tag: '国漫', imgUrl: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20digital%20art%20with%20traditional%20ink%20painting%20and%20modern%20illustration%20fusion%2C%20fantasy%20characters%20with%20flowing%20energy%2C%20warm%20golden%20and%20amber%20tones%2C%20epic%20cinematic%20composition%2C%20artistic%20masterpiece&width=800&height=500&seq=carousel-cn-01&orientation=landscape' },
  { id: 4, title: '下拉式阅读：漫画观看方式的革命', desc: '告别翻页，拥抱滚动。下拉式阅读让漫画画面自然衔接，彻底消除了翻页带来的阅读中断感。无论电脑还是手机，一滑到底的体验让追漫成为纯粹的享受。', tag: '特色', imgUrl: 'https://readdy.ai/api/search-image?query=Modern%20tablet%20and%20smartphone%20displaying%20continuous%20scroll%20comic%20reading%20experience%2C%20finger%20swiping%20vertically%2C%20cozy%20ambient%20lighting%2C%20warm%20coffee%20shop%20background%2C%20clean%20minimal%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=carousel-scroll-01&orientation=landscape' },
  { id: 5, title: '漫荒救星：冷门佳作挖掘计划', desc: '热榜之外，还有大量被埋没的好作品等待发现。我们每周精选评分高但热度尚低的优质漫画，帮你开拓新的阅读疆域。', tag: '推荐', imgUrl: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20manga%20books%20discovered%20in%20a%20cozy%20bookstore%20corner%2C%20warm%20spotlight%20on%20unique%20comic%20volumes%2C%20artistic%20flat%20lay%20with%20soft%20natural%20light%2C%20amber%20and%20cream%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=carousel-hidden-01&orientation=landscape' },
];

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">漫画文化探索</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">深入了解韩漫、日漫、国漫的文化背景与阅读方式</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsItems.map((item) => (
            <div key={item.id} className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden group cursor-pointer">
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.imgUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-[11px] font-medium mb-2">{item.tag}</span>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 font-body">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardsItemsRow.map((item) => (
            <div key={item.id} className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden group cursor-pointer flex flex-col sm:flex-row">
              <div className="w-full sm:w-48 flex-shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={item.imgUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-[11px] font-medium mb-2 self-start">{item.tag}</span>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 font-body">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">漫画资讯速递</h2>
          <p className="text-sm md:text-base text-foreground-500">漫画圈最新动态与热门资讯一览</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item) => (
            <div key={item.id} className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden group cursor-pointer">
              <div className="aspect-video overflow-hidden bg-background-200 relative">
                <img
                  src={item.imgUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl text-foreground-800 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-[11px] font-medium mb-2">{item.tag}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-body line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500">漫画爱好者正在热议的话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item, idx) => (
            <div key={item.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border cursor-pointer transition-colors ${
                idx < 3
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200/70 hover:border-primary-200/50 hover:bg-primary-50/50'
              }`}
            >
              <span className={`text-sm font-medium ${idx < 3 ? 'text-primary-600' : 'text-foreground-700'}`}>{item.name}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-sm text-foreground-500">韩漫、日漫、国漫爱好者聚集地，来话题广场找到同好</p>
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500">漫画更新、新作上架与站点资讯实时追踪</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updatesData.map((item) => (
              <div key={item.id} className="relative flex gap-4 pl-12">
                <div className="absolute left-[15px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100 ring-2 ring-primary-100"></div>

                <div className="flex-1 pb-5 border-b border-background-200/70 last:border-b-0 last:pb-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-md">{item.date}</span>
                    <span className="text-xs text-foreground-500">{item.tag}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 font-body">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">{appData.title}</h2>
              <p className="text-sm md:text-base text-background-100/90 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                {appData.description}
              </p>
              <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto lg:mx-0">
                {appData.features.map((feat, i) => (
                  <div key={i} className="flex items-center gap-2 text-background-50/90">
                    <i className="ri-checkbox-circle-fill text-background-50 text-sm flex-shrink-0"></i>
                    <span className="text-xs md:text-sm">{feat}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-50/15 backdrop-blur flex items-center justify-center border border-background-50/20">
                <div className="text-center">
                  <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50"></i>
                  <p className="text-background-50/80 text-xs mt-3 font-medium">手机浏览器访问</p>
                  <p className="text-background-50/60 text-[11px] mt-1">添加至桌面使用</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-500">深度探索韩漫、日漫、国漫的精彩世界</p>
        </div>

        <div className="overflow-x-auto pb-4">
          <div className="flex gap-5 min-w-max px-1">
            {carouselItems.map((item) => (
              <div key={item.id}
                className="w-[320px] sm:w-[360px] md:w-[400px] flex-shrink-0 rounded-xl bg-background-50 border border-background-200/70 overflow-hidden group cursor-pointer relative"
              >
                <div className="aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={item.imgUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-800 text-[11px] font-medium backdrop-blur">{item.tag}</span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 font-body">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">特色优势</h2>
          <p className="text-sm md:text-base text-foreground-500">为什么漫画爱好者选择虫虫动漫</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((item, idx) => (
            <div key={item.id} className="text-center p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5 ${
                idx === 0 ? 'bg-primary-100' : idx === 1 ? 'bg-accent-100' : 'bg-secondary-100'
              }`}>
                <i className={`${item.icon} text-2xl ${
                  idx === 0 ? 'text-primary-500' : idx === 1 ? 'text-accent-500' : 'text-secondary-500'
                }`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3 font-body">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}